// Trafalgar Releasing — store-specific JS

// Mega menu: open on hover instead of click
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header__inline-menu .mega-menu').forEach(function (details) {
    let closeTimer;

    function open() {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    }

    function scheduleClose() {
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 150);
    }

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', scheduleClose);

    // Keep open when hovering over the content panel
    const content = details.querySelector('.mega-menu__content');
    if (content) {
      content.addEventListener('mouseenter', open);
      content.addEventListener('mouseleave', scheduleClose);
    }

    // Prevent click on summary from toggling (hover controls it)
    details.querySelector('summary').addEventListener('click', function (e) {
      e.preventDefault();
    });
  });
});
